import { ClerkProvider } from '@clerk/react';
import { useAuth } from '@clerk/react';
import { useRef, useEffect, type ReactNode } from 'react';
import {
  registerClerkTokenProvider,
  clearClerkTokenProvider,
} from '@client/api/clerkTokenProvider';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

function ClerkTokenBridge({ children }: { children: ReactNode }) {
  const { isSignedIn, isLoaded, getToken } = useAuth();
  const getTokenRef = useRef(getToken);
  getTokenRef.current = getToken;

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      registerClerkTokenProvider(() => getTokenRef.current());
    } else {
      clearClerkTokenProvider();
    }
    return () => clearClerkTokenProvider();
  }, [isLoaded, isSignedIn]);

  return <>{children}</>;
}

export function ClerkAuthProvider({ children }: { children: ReactNode }) {
  if (!CLERK_PUBLISHABLE_KEY) {
    return <>{children}</>;
  }

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      signInFallbackRedirectUrl="/"
    >
      <ClerkTokenBridge>{children}</ClerkTokenBridge>
    </ClerkProvider>
  );
}
